/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#exportAnnotations__anchor
 */
export default options => window.documentViewer.getAnnotationManager().exportAnnotations(options);
